import { ActionReducer } from '@ngrx/store';
import { OnboardingModuleStatuses } from 'src/app/core/enums/onboarding-module-status.enum';
import { StateManagementHelpers } from '../../helpers';
import * as EnrollmentActions from '../actions/enrollment.actions';
import { IEnrollmentStore } from '../interfaces/enrollment-store.interface';

const defaultEnrollmentStore: IEnrollmentStore = {
  enrollmentId: '',
  enrollmentStepId: -1,
  dashboardStateId: '-1',
  businessProfileStateId: '-1',
  financialProfileStateId: '-1',
  customerPortfolioStateId: '-1',
  businessProfileStatusId: OnboardingModuleStatuses.INACTIVE,
  financialProfileStatusId: OnboardingModuleStatuses.INACTIVE,
  customerPortfolioStatusId: OnboardingModuleStatuses.INACTIVE,
  applicationReviewStatusId: OnboardingModuleStatuses.INACTIVE,
  msaSignatureStatusId: OnboardingModuleStatuses.INACTIVE,
  nowAccountActivationStatusId: OnboardingModuleStatuses.INACTIVE,
  hasClientAdditionalInfoRequest: false,
};

export const createEnrollmentReducer: ActionReducer<
  IEnrollmentStore | undefined,
  any
> = (
  // eslint-disable-next-line default-param-last
  state: IEnrollmentStore = defaultEnrollmentStore,
  action: any
): IEnrollmentStore | undefined => {
  switch (action.type) {
    case EnrollmentActions.ENROLLMENT_ID:
      return StateManagementHelpers.mergeState(state, {
        enrollmentId: action.enrollmentId,
      }) as IEnrollmentStore;
    case EnrollmentActions.DASHBOARD_STATE_ID:
      return StateManagementHelpers.mergeState(state, {
        dashboardStateId: action.dashboardStateId,
      }) as IEnrollmentStore;
    case EnrollmentActions.BUSINESS_PROFILE_STATE_ID:
      return StateManagementHelpers.mergeState(state, {
        dashboardStateId: action.dashboardStateId,
        businessProfileStateId: action.businessProfileStateId,
      }) as IEnrollmentStore;
    case EnrollmentActions.FINANCIAL_PROFILE_STATE_ID:
      return StateManagementHelpers.mergeState(state, {
        dashboardStateId: action.dashboardStateId,
        financialProfileStateId: action.financialProfileStateId,
      }) as IEnrollmentStore;
    case EnrollmentActions.ONLY_FINANCIAL_PROFILE_STATE_ID:
      return StateManagementHelpers.mergeState(state, {
        financialProfileStateId: action.financialProfileStateId,
      }) as IEnrollmentStore;
    case EnrollmentActions.CUSTOMER_PORTFOLIO_STATE_ID:
      return StateManagementHelpers.mergeState(state, {
        dashboardStateId: action.dashboardStateId,
        customerPortfolioStateId: action.customerPortfolioStateId,
      }) as IEnrollmentStore;
    case EnrollmentActions.ENROLLMENT_STEP_ID:
      return StateManagementHelpers.mergeState(state, {
        enrollmentStepId: action.enrollmentStepId,
      }) as IEnrollmentStore;
    case EnrollmentActions.BUSINESS_PROFILE_STATUS_ID:
      return StateManagementHelpers.mergeState(state, {
        businessProfileStatusId: action.businessProfileStatusId,
      }) as IEnrollmentStore;
    case EnrollmentActions.FINANCIAL_PROFILE_STATUS_ID:
      return StateManagementHelpers.mergeState(state, {
        financialProfileStatusId: action.financialProfileStatusId,
      }) as IEnrollmentStore;
    case EnrollmentActions.CUSTOMER_PORTFOLIO_STATUS_ID:
      return StateManagementHelpers.mergeState(state, {
        customerPortfolioStatusId: action.customerPortfolioStatusId,
      }) as IEnrollmentStore;
    case EnrollmentActions.APPLICATION_REVIEW_STATUS_ID:
      return StateManagementHelpers.mergeState(state, {
        applicationReviewStatusId: action.applicationReviewStatusId,
      }) as IEnrollmentStore;
    case EnrollmentActions.MSA_SIGNATURE_STATUS_ID:
      return StateManagementHelpers.mergeState(state, {
        msaSignatureStatusId: action.msaSignatureStatusId,
      }) as IEnrollmentStore;
    case EnrollmentActions.NOWACCOUNT_ACTIVATION_STATUS_ID:
      return StateManagementHelpers.mergeState(state, {
        nowAccountActivationStatusId: action.nowAccountActivationStatusId,
      }) as IEnrollmentStore;
    case EnrollmentActions.HAS_CLIENT_ADDITIONAL_INFO_REQUEST:
      return StateManagementHelpers.mergeState(state, {
        hasClientAdditionalInfoRequest: action.hasClientAdditionalInfoRequest,
      }) as IEnrollmentStore;
    case EnrollmentActions.ALL:
      return StateManagementHelpers.mergeState(state, {
        enrollmentId: action.enrollmentId,
        enrollmentStepId: action.enrollmentStepId,
        dashboardStateId: action.dashboardStateId,
        businessProfileStateId: action.businessProfileStateId,
        financialProfileStateId: action.financialProfileStateId,
        customerPortfolioStateId: action.customerPortfolioStateId,
        businessProfileStatusId: action.businessProfileStatusId,
        financialProfileStatusId: action.financialProfileStatusId,
        customerPortfolioStatusId: action.customerPortfolioStatusId,
        applicationReviewStatusId: action.applicationReviewStatusId,
        msaSignatureStatusId: action.msaSignatureStatusId,
        nowAccountActivationStatusId: action.nowAccountActivationStatusId,
        hasClientAdditionalInfoRequest: action.hasClientAdditionalInfoRequest,
      }) as IEnrollmentStore;
    default:
      return state;
  }
};
